module.exports = {"TXTWCL_WeXre_working_on_this":{"id":"TXTWCL_WeXre_working_on_this","defaultMessage":"処理中です"}}